// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeInviteUserSearchBody = {
  poolId: string;
  query: string;
};

export type typeInviteUserSearchOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    items: {
      userId: string;
      username: string;
      displayName: string;
      avatarUrl?: string | null;
      relation: "none" | "member" | "invited" | "blocked";
    }[];
    total: number;
  };
};

export type typeInviteUserSearchOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteUserSearchOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeInviteUserSearchOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaInviteUserSearchBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    query: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "query"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createInviteUserSearch(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaInviteUserSearchBody);
  }

  return async function postInviteUserSearch(
    payload: typeInviteUserSearchBody,
  ): Promise<typeInviteUserSearchOutput200 | typeInviteUserSearchOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postInviteUserSearch" failed before calling the network. #6b1000a54619`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#6b1000a54619" },
        },
        data: null,
      } as typeInviteUserSearchOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/invite/user-search`,
      httpMethod: "POST",
      options,
    })) as typeInviteUserSearchOutput200 | typeInviteUserSearchOutput400;
  };
}
